import proxyClient from '@/plugins/axios/proxyClient'
import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  postCreditPaysRequest(body) {
    return proxyClient.post(`/credit-pays/request`, body)
  },

  getCreditPaysRequests(query) {
    return proxyClient.get(`/credit-pays/request?${qs.stringify(query)}`)
  },

  getCreditPaysRequestDetail(uuid) {
    return proxyClient.get(`/credit-pays/request/` + uuid)
  },

  cancelCreditPaysRequestDetail(uuid) {
    return proxyClient.put(`/credit-pays/request/${uuid}/cancel`)
  },

  getCreditPaysRequestFiles(uuid) {
    return proxyClient.get(`/credit-pays/request/${uuid}/files`)
  },

  postCreditPaysRequestFile(uuid, file) {
    const formData = new FormData()
    formData.append('file', file)

    return defaultClient.post(`credit-pays/requests/${uuid}/upload-file/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
